import {
  GROUP_AUDIENCE_LABEL,
  RECIPIENT_AUDIENCE_LABEL,
} from 'src/modules/campaigns/helpers';

// Classifies a campaign type for the "Save as Preset" audience checkbox.
// `label` is the checkbox text. Returns null for campaign types that have no
// group-based audience (reminder/annual target by appointment type or
// birthday; away_message/text_to_win have no audience selection).
export type PresetAudienceField = { label: string };

export function getPresetAudienceField(
  campaignType: string
): PresetAudienceField | null {
  switch (campaignType) {
    case "message":
      return { label: RECIPIENT_AUDIENCE_LABEL };
    case "join":
    case "enrollment":
    case "recurring":
      return { label: GROUP_AUDIENCE_LABEL };
    default:
      return null;
  }
}
